import { ReactQueryKeys } from "../../../constants/ReactQueryKeys";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  hoursToMinutes,
  minutesToMs,
} from "../../../utils/numberComputationHelper/numberComputationHelper";
import { sessionStorageWrapper } from "../../../utils/sessionStorageWrapper/sessionStorageWrapper";
import { PersistedClient } from "@tanstack/react-query-persist-client";
import { filterWithMultipleValues } from "../../../utils/arrayHelper/arrayHelper";
import { CommercialNonWorkingDay } from "../../../types/CommercialNonWorkingDay";
import getCommercialNonWorkingDays from "../../../services/CalenderService";

export const useGetCommercialNonWorkingDays = () => {
  const queryKey: ReactQueryKeys = "commercialNonWorkingDays";

  const ecssQueryCache =
    sessionStorageWrapper.getItem<PersistedClient>("ecssQueryCache");

  const [firstQuery] = filterWithMultipleValues(
    ecssQueryCache?.clientState?.queries,
    [queryKey],
    (query, filter) =>
      query.queryKey.includes(filter) && !query.state.isInvalidated,
  );

  const cachedNonWorkingDays = firstQuery?.state?.data as
    | CommercialNonWorkingDay[]
    | undefined;

  const minutes = hoursToMinutes(24);
  const queryClient = useQueryClient();
  queryClient.setQueryDefaults([queryKey], {
    staleTime: minutesToMs(minutes),
    cacheTime: minutesToMs(minutes),
  });

  const {
    data: nonWorkingDays,
    isError: apiError,
    isLoading: loading,
  } = useQuery<CommercialNonWorkingDay[]>({
    queryKey: [queryKey],
    queryFn: () => getCommercialNonWorkingDays(),
    enabled: !cachedNonWorkingDays,
  });

  return {
    commercialNonWorkingDays: cachedNonWorkingDays ?? nonWorkingDays ?? [],
    apiError,
    loading,
  };
};
